import { CSSProperties, Key, ReactNode, } from 'react';
// 组件
import {
  FileSearchOutlined,
  FormOutlined,
  DeleteOutlined,
  RiseOutlined,
  DownloadOutlined,
  PlusOutlined,
  ConsoleSqlOutlined,
  ApiOutlined,
  PrinterOutlined,
  UploadOutlined,
  StopOutlined,
  IssuesCloseOutlined,
  SnippetsOutlined,
  CheckSquareOutlined,
  UserAddOutlined,
  CarryOutOutlined,
  CreditCardOutlined,
  ClearOutlined,
  MoneyCollectOutlined,
  CopyOutlined,
  CloseCircleOutlined,
  BranchesOutlined,
  ExportOutlined,
  LockOutlined,
  UnlockOutlined,
  KeyOutlined,
  CheckCircleOutlined,
} from '@ant-design/icons';
// 常量
import { FormInstance } from 'antd/lib/form';
import { PaginationProps } from 'antd/lib/pagination';
import { TooltipProps } from 'antd/lib/tooltip';
import { PopoverTableProps } from '../../PopoverTable/interface';
import { IBtnList } from '../../ButtonGroup/buttonGroup';
import { AlignType, IObject, moneyColumnsProps } from '../../constants/interface';
import { EditSelectProps } from '../../EditSelect';
import { RouteLinkProps } from '../../RouteLink/interface';
import { DataStatusProps } from '../../DataStatus/interface';
import { OptionItem } from '../../GoodInfoColumn/interface';
import { SkuInfoListProps } from '../../SkuInfoList';
import { TableColumnProps } from 'antd';

export interface ColumnsRouteLinkProps extends RouteLinkProps {
  query?: ((record: any) => IObject) | IObject;
  state?: ((record: any) => IObject) | IObject;
}
/** boolean值列展示配置 */
export interface booleanProps {
  /** true 展示内容 默认 是 */
  checkedChildren: ReactNode,
  /** false 展示内容 默认 否 */
  unCheckedChildren: ReactNode,
};

export interface IFormatColumns {
  left: columnsProps[];
  right: columnsProps[];
  content: columnsProps[];
}
/** 列表参数对象 */
export interface ListParamsProps {
  searchParams: Object;
  paginationParams: PaginationProps | false;
}

export interface IselectedInfo {
  selectedRowKeys?: Key[];
  selectedRows?: any[];
}
export interface TableAction {
  /** 刷新表格 */
  reload: (resetPageIndex?: boolean, params?: IObject) => void;
  /** 重置 */
  reset: () => void;
  /** 重置分页 */
  resetPagination: () => void;
  /** 获取表格数据源 */
  getDataSource: () => any[];
  /** 重置搜索表单 */
  resetFields: (params?: any) => void;
  /** 设置表格数据 */
  setDataSource: (dataSource: any[]) => void;
  /** 搜索表单提交 */
  submit: () => void;
  /** 刷新草稿箱数量 */
  reloadDraftsCount: () => void;
  /** 设置表格高度 */
  setTableHeight: () => void;
  /** 获取列表参数 */
  getTableParams: () => Promise<ListParamsProps>;
  /** 清空选中项 */
  emptySelect: () => void;
  /** 设置表格为加载中状态 */
  loading: () => void;
  /** 移除表格加载中状态 */
  unLoading: () => void;
  /** 获取选中数据 */
  getSelectedInfo: () => IselectedInfo;
  /** 刷新列配置 */
  reloadColumns: (columns?: columnsProps[]) => void;
  /** */
  form?: FormInstance;
}
export type TableActionType = TableAction | undefined;
export type tableSizeType = 'middle' | 'large' | 'small';
export type CommonlyType =
  | 'detail'
  | 'edit'
  | 'delete'
  | 'upgrade'
  | 'download'
  | 'add'
  | 'queryExecute'
  | 'queryUnexecute'
  | 'printContract'
  | 'submitReview'
  | 'unSubmitReview'
  | 'audit'
  | 'sign'
  | 'complete'
  | 'selectQC'
  | 'attachOp'
  | 'settleAccounts'
  | 'forInvalid'
  | 'paymentCom'
  | 'copyCreate'
  | 'invalid'
  | 'bindShipmentId'
  | 'readyDelivery'
  | 'disabled'
  | 'enabled'
  | 'authorize'
  | 'cancel'
  | 'confirmDelivery'
  | 'oneKeyInbound'
  | 'submit'
  | 'passed'
  | 'rejected';
export interface ICommonlyTypeEnum {
  /** 详情 */
  detail: IBtnList;
  /** 编辑 */
  edit: IBtnList;
  /** 删除 */
  delete: IBtnList;
  /** 版本升级 */
  upgrade: IBtnList;
  /** 下载 */
  download: IBtnList;
  /** 新增 */
  add: IBtnList;
  /** 查询已执行脚本 */
  queryExecute: IBtnList;
  /** 查询可执行脚本 */
  queryUnexecute: IBtnList;
  /** 打印合同 */
  printContract: IBtnList;
  /** 提交审核 */
  submitReview: IBtnList;
  /** 撤回审核 */
  unSubmitReview: IBtnList;
  /** 审核 */
  audit: IBtnList;
  /** 下单 */
  sign: IBtnList;
  /** 完结 */
  complete: IBtnList;
  /** 指派QC */
  selectQC: IBtnList;
  /** 跟踪 */
  attachOp: IBtnList;
  /** 结算 */
  settleAccounts: IBtnList;
  /** 作废审核 */
  forInvalid: IBtnList;
  /** 支付完成 */
  paymentCom: IBtnList;
  /** 复制新增 */
  copyCreate: IBtnList;
  /** 作废 */
  invalid: IBtnList;
  /** 核销 */
  writeOff: IBtnList;
  /** 绑定ShipmentId */
  bindShipmentId: IBtnList;
  /** 通知发货 */
  readyDelivery: IBtnList;
  /** 禁用 */
  disabled: IBtnList;
  /** 启用 */
  enabled: IBtnList;
  /** 授权 */
  authorize: IBtnList;
  /** 取消 */
  cancel: IBtnList;
  /** 确认出库 */
  confirmDelivery: IBtnList;
  /** 一键入库 */
  oneKeyInbound: IBtnList;
  /** 导出 */
  export: IBtnList;
  /** 提交 */
  submit: IBtnList;
  /** 通过 */
  passed: IBtnList;
  /** 驳回 */
  rejected: IBtnList;
}
export const CommonlyTypeEnum: ICommonlyTypeEnum = {
  detail: {
    label: '查看',
    icon: <FileSearchOutlined />,
    key: 'detail',
  },
  edit: {
    label: '编辑',
    icon: <FormOutlined />,
    key: 'edit',
  },
  delete: {
    label: '删除',
    icon: <DeleteOutlined />,
    key: 'delete',
    danger: true,
  },
  upgrade: {
    label: '版本升级',
    icon: <RiseOutlined />,
    key: 'upgrade',
  },
  download: {
    label: '下载',
    icon: <DownloadOutlined />,
    key: 'download',
  },
  add: {
    label: '新增',
    icon: <PlusOutlined />,
    key: 'add',
  },
  queryExecute: {
    label: '查询已执行脚本',
    icon: <ConsoleSqlOutlined />,
    key: 'queryExecute',
  },
  queryUnexecute: {
    label: '查询可执行脚本',
    icon: <ApiOutlined />,
    key: 'queryUnexecute',
  },
  printContract: {
    label: '打印合同',
    icon: <PrinterOutlined />,
    key: 'printContract',
  },
  submitReview: {
    label: '提交审核',
    icon: <UploadOutlined />,
    key: 'submitReview',
  },
  unSubmitReview: {
    label: '撤回审核',
    icon: <StopOutlined />,
    key: 'unSubmitReview',
  },
  audit: {
    label: '审核',
    icon: <IssuesCloseOutlined />,
    key: 'audit',
  },
  sign: {
    label: '下单',
    icon: <SnippetsOutlined />,
    key: 'sign',
  },
  complete: {
    label: '完结',
    icon: <CheckSquareOutlined />,
    key: 'complete',
  },
  selectQC: {
    label: '指派QC',
    icon: <UserAddOutlined />,
    key: 'selectQC',
  },
  attachOp: {
    label: '跟踪',
    icon: <CarryOutOutlined />,
    key: 'attachOp',
  },
  settleAccounts: {
    label: '结算',
    icon: <CreditCardOutlined />,
    key: 'settleAccounts',
  },
  forInvalid: {
    label: '作废审核',
    icon: <ClearOutlined />,
    key: 'forInvalid',
  },
  paymentCom: {
    label: '支付完成',
    icon: <MoneyCollectOutlined />,
    key: 'paymentCom',
  },
  copyCreate: {
    label: '复制新增',
    icon: <CopyOutlined />,
    key: 'copyCreate',
  },
  invalid: {
    label: '作废',
    icon: <CloseCircleOutlined />,
    key: 'invalid',
  },
  writeOff: {
    label: '核销',
    icon: <CheckSquareOutlined />,
    key: 'writeOff',
  },
  bindShipmentId: {
    label: '绑定ShipmentId',
    icon: <BranchesOutlined />,
    key: 'bindShipmentId',
  },
  readyDelivery: {
    key: 'readyDelivery',
    label: '通知备货',
    icon: <ExportOutlined />,
  },
  disabled: {
    key: 'disabled',
    label: '禁用',
    icon: <LockOutlined />,
  },
  enabled: {
    key: 'enabled',
    label: '启用',
    icon: <UnlockOutlined />,
  },
  authorize: {
    key: 'authorize',
    label: '授权',
    icon: <KeyOutlined />,
  },
  cancel: {
    key: 'cancel',
    label: '取消',
    icon: <CloseCircleOutlined />,
    danger: true,
  },
  confirmDelivery: {
    key: 'confirmDelivery',
    label: '确认出库',
    icon: <ExportOutlined />,
  },
  oneKeyInbound: {
    key: 'oneKeyInbound',
    label: '一键入库',
    icon: <CheckCircleOutlined />,
  },
  export: {
    key: 'export',
    label: '导出',
    icon: <DownloadOutlined />,
  },
  submit: {
    label: '提交',
    icon: <UploadOutlined />,
    key: 'submit',
  },
  passed: {
    label: '通过',
    icon: <CheckCircleOutlined />,
    key: 'passed',
  },
  rejected: {
    label: '驳回',
    danger: true,
    icon: <CloseCircleOutlined />,
    key: 'rejected',
  },
};

export interface IEditableProps {
  /** 列表接口api */
  fetchApi: (params: any) => Promise<any>;
  /** key字段 */
  rowKey: string;
  /** 自定义编辑图标 */
  icon?: ReactNode;
  /** 编辑中文本域最大长度 */
  maxLength?: number;
  /** 自定义提示文本，为 false 时关闭 */
  tooltip?: boolean | ReactNode;
  /** 搜索名称 */
  searchName?: string;
  /** key名称 默认名称与字段相同 */
  rowKeyName?: string;
  /** 参数 */
  formatParams?: (params: any, record: any) => any;
}
export interface ColumnEditSelectProps extends Omit<EditSelectProps, 'disabled'> {
  defaultParams?: Object | ((record: any, index: number) => Object);
  labelKey?: string;
  valueKey?: string;
  disabled?: boolean | ((text: any, record: any, index: number) => boolean);
}
/** 商品信息列props */
export interface productInfoProps {
  /** 样式 */
  style?: CSSProperties | ((productInfo: any, record: any) => CSSProperties);
  /** 类名 */
  className?: string | ((productInfo: any, record: any) => string);
  /** 宽度 */
  width?: number | ((productInfo: any, record: any) => number);
  /** 图片 */
  image?: string | ((productInfo: any, record: any) => string);
  /** 是否显示图片 */
  showImage?: boolean | ((productInfo: any, record: any) => boolean);
  /** 标题 */
  title?: ReactNode | ((productInfo: any, record: any) => ReactNode);
  /** 标签前缀 */
  titlePrefix?: ReactNode | ((productInfo: any, record: any) => ReactNode);
  /** 标题是否可以复制 */
  copyTitle?: boolean | ((productInfo: any, record: any) => boolean);
  /** 其他参数 */
  options?: OptionItem[] | ((productInfo: any, record: any) => OptionItem[]);
}
/** 表格单元格气泡列表配置 */
export interface ColumnPopoverTableProps extends Omit<PopoverTableProps, 'dataSource' | 'title'> {
  dataSource?: any[] | ((record: any) => any[]),
  title?: ReactNode | ((record: any) => ReactNode);
}
/**
 * renderType属性不能用于主子表(MainSubTable)的第一列
 */
export interface columnsProps {
  /** 列头显示文字 */
  title?: ReactNode;
  /** 列数据在数据项中对应的路径，支持通过数组查询嵌套路径 */
  dataIndex?: string | string[];
  /** 单元格类型 */
  renderType?:
    | 'image'
    | 'images'
    | 'boolean'
    | 'copy'
    | 'popoverList'
    | 'money'
    | 'select'
    | 'time'
    | 'routeLink'
    | 'dataStatus'
    | 'productInfo'
    | 'productInfoList'
    | 'numberMark'
    | 'skuInfoList';
  /** 可以复制的行 */
  copyLine?: number[];
  /** 超过多少行出现省略号，最大支持3 */
  ellipsisLine?: 1 | 2 | 3;
  /** 枚举名称 */
  enumName?: string;
  /** 列宽度 */
  width?: string | number;
  /** 生成复杂数据的渲染函数，参数分别为当前行的值，当前行数据，行索引, 分页信息 */
  render?: (text: any, record: any, index: number, pagination?: false | PaginationProps) => ReactNode;
  /** 列是否固定，可选 true (等效于 left) left right */
  fixed?: boolean | 'left' | 'right';
  /** React 需要的 key，如果已经设置了唯一的 dataIndex，可以忽略这个属性 */
  key?: string;
  /** 表头列合并,设置为 0 时，不渲染 */
  colSpan?: number;
  /** 设置列的对齐方式 */
  align?: AlignType;
  /** 列样式类名 */
  className?: string;
  /** 嵌套子标题 */
  children?: columnsProps[];
  /** 超过宽度将自动省略 */
  ellipsis?: any;
  /** 当前列是否隐藏  */
  isHide?: boolean;
  /** 图片是否有缩略图 */
  isLocal?: boolean;
  /** 设置自定义列对应的key值 */
  toolbarIndex?: number;
  /** 当前列是否可编辑 */
  editable?: IEditableProps | false;
  /** 气泡列表配置 */
  popoverProps?: ColumnPopoverTableProps;
  /** 金额配置 */
  moneyProps?: moneyColumnsProps;
  /** 下拉编辑配置 */
  editSelect?: ColumnEditSelectProps;
  /** 文字提示 */
  tooltip?: string | TooltipProps;
  /** 商品信息列 */
  productInfoProps?: productInfoProps;
  /** SKU信息列 */
  skuInfoListProps?: SkuInfoListProps;
  /** 格式化需要复制数据 */
  formatCopyValue?: (value: any, record: any, index: number) => any;
  /** 自定义单元格渲染时机 */
  shouldCellUpdate?: (record: any, prevRecord: any) => boolean;
  onHeaderCell?: any;
  /** 日期类型 */
  timeProps?: {
    zoneTypeKey: string;
    initialValue?: string;
    render?: (text: any, record: any, key: number) => ReactNode;
    zoneOption: {
      value: string;
      label: string;
      dataIndex?: string;
      render?: (text: any, record: any, key: number) => ReactNode;
    }[];
  };
  /** 链接 */
  routeLinkProps?: ColumnsRouteLinkProps;
  /** 数据状态配置 */
  dataStatusProps?: DataStatusProps;
  /** 布尔值配置 */
  booleanProps?: booleanProps;
  /** 设置单元格属性 */
  onCell?: TableColumnProps<any>['onCell'];
}
export interface operationColumnsProps extends Omit<columnsProps, 'render'> {
  customRender?: (
    text: string,
    record: any,
    index: number,
  ) => IBtnList[] | CommonlyType[];
  render?:
    | IBtnList[]
    | ((text: string, record: any, index: number) => ReactNode);
}
export type operationType =
  | operationColumnsProps
  | false
  | CommonlyType
  | (CommonlyType | IBtnList)[];

export interface tableDraftsProps {
  /** 草稿箱接口 */
  fetchApi: (params: any) => Promise<any>;
  /** 草稿箱数量接口 */
  fetchNumApi?: (params: any) => Promise<any>;
  /** 参数 */
  params?: any;
  /** 按钮文字 */
  text?: string;
  /** 弹窗标题 */
  title?: string;
  /** 草稿箱权限code */
  authorityCode?: string;
  /** 点击确定回调 */
  onOk?: (selectedRows?: any) => void;
  /** 删除回调 */
  onDelete?: (record: any) => void;
}

export type draftsType = tableDraftsProps | false;

export interface IGroupField {
  nameKey: string;
  valueKey: string;
}

/** 表格context */
export interface ScrollContextProps {
  /** 渲染中的第一条向上偏移量 */
  offsetStart?: number;
  /** 渲染条数 */
  renderLen: number;
  /** 渲染中的第一条 */
  start: number;
  /**  */
}
